import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import PreprimarySidebar2026 from '../PreprimarySidebar2026';
import Presidebar2026 from '../Presidebar2026/Presidebar2026';


const EnvironmentDayCelebrationkg2026= () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
   const p1 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/Environmentkg/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/Environmentkg/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/Environmentkg/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/Environmentkg/4.webp`;
  const p5 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/Environmentkg/5.webp`;
  const p6 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/Environmentkg/6.webp`;
  const p7 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/Environmentkg/7.webp`;
  const p8 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/Environmentkg/8.webp`;
  const p9 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/Environmentkg/9.webp`;
  const p10 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/Environmentkg/10.webp`;
  const p11 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/Environmentkg/11.webp`;
  const p12 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/Environmentkg/12.webp`;
  const p13 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/Environmentkg/13.webp`;
  const p14 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/Environmentkg/14.webp`;
  
  
   
  const photos = [
    {
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5,
    rows: 1,
    cols: 1,
},
{
    src: p6,
    source: p6,
    rows: 1,
    cols: 1,
},
{
    src: p7,
    source: p7,
    rows: 1,
    cols: 1,
},
 {
    src: p8,
    source: p8,
    rows: 1,
    cols: 1,
},
{
    src: p9,
    source: p9,
    rows: 1,
    cols: 1,
},
{
    src: p10,
    source: p10,
    rows: 1,
    cols: 1,
},
{
    src: p11,
    source: p11,
    rows: 1,
    cols: 1,
},
{
    src: p12,
    source: p12,
    rows: 1,
    cols: 1,
},
{
    src: p13,
    source: p13,
    rows: 1,
    cols: 1,
},
{
    src: p14,
    source: p14,
    rows: 1,
    cols: 1,
},

  ];

  return (
    <Main>
   
<Container>

  <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center' >
      Environment Day Celebration-KG
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
      Classes: KINDERGARTEN      Date: 25 June 2026
        </Typography>
        <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
Be a Part of the Solution, Not Pollution – Let’s Recycle, Reuse and Reduce
<br></br>
        </Typography>


       <Typography variant={'subtitle1'} align={'justify'}>
  The Pre-primary Department celebrated <b>Environment Day</b> on Thursday, 25th June 2026, with great enthusiasm to create awareness among our little learners about protecting and caring for our planet.
  <br></br>
  The celebration began with the <b>Go Green Parade</b>, where children dressed in colour-coded costumes marched around the school carrying placards and chanting environmental slogans, inspiring everyone to work towards a greener future. The day concluded with a beautiful art activity that reinforced the importance of caring for our environment.
  <br></br>

  Each class participated in engaging hands-on activities:
  <br></br>
  <b>Pre-K: "SMALL HANDS CAN PROTECT OUR BIG WORLD"</b>
  <br></br>
  Our little ones participated in a seed germination activity to understand how plants grow.
  <br></br><br></br>

  <b>KGI A: "BUDDING GARDENERS"</b>
  <br></br>
  Our young learners sowed seed balls and learnt to segregate waste into paper, plastic, metal, and organic categories.
  <br></br><br></br>

  <b>KGI B: "ECO WARRIORS"</b>
  <br></br>
  Our young learners practised sorting recyclable and non-recyclable waste, promoting responsible environmental habits.
  <br></br><br></br>

  <b>KGII A: "LET'S SEA THE BLUE"</b>
  <br></br>
  Our marine life saviours carefully removed waste from a water-filled container using tongs to learn about protecting aquatic life. They also participated in a fun activity on eco-friendly Do's and Don'ts.
  <br></br><br></br>

  <b>KGII B: "WONDER OF SEED"</b>
  <br></br>
  Our little scientists eagerly participated in a fascinating chia seed experiment and enjoyed a nature walk with a scavenger hunt to observe the environment.
  <br></br><br></br>

  <b>KGII C: "AROUND THE GLOBE"</b>
  <br></br>
  Our young environmentalists placed picture cards on a globe, identifying things that protect the Earth, such as trees, water, animals, and plants, while recognising harmful elements like plastic and litter. They also enjoyed an engaging story on caring for nature.
  <br></br>
</Typography>

      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>

<br/>
        </Typography>

      <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 300 : 200}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>

    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <PreprimarySidebar2026 />
             </Box>
             <Box marginBottom={4}>
               <Presidebar2026 />
             </Box>


    </Grid>
    </Grid> 
    </Container>
    </Main>
   
   
  );
};

export default EnvironmentDayCelebrationkg2026;